angular.module("warsApp.factories").factory('timeZoneInterceptor', function () {
    var timeZoneName = undefined;

    return {
        request: function (config) {

            if (timeZoneName === undefined) {
                timeZoneName = warsApp.DateTimeHelper.GetLongTimeZoneName();
            }

            config.headers['Client-Time-Zone-Name'] = timeZoneName;
            return config;
        }
    };
});